import request from "superagent";
import {API_URL} from "./base";

export type CampaignImage = {
    url: string,
    breakpoint: number
}
export type Campaign = {
    id: number,
    slug: string,
    url: string,
    title: string,
    subtitle: string,
    description: string,
    updated_at: Date,
    preview_images: CampaignImage[],
    cover_images: CampaignImage[],
}

export type Carousel = {
    id: string,
    venue_ids: string[],
    title: string,
    description: string,
}
export function GetAllCampaigns(latitude: number, longitude: number, token: string) : Promise<Campaign[]> {
    return new Promise((resolve, reject) => {
        request
            .get(`${API_URL}campaigns?latitude=${latitude}&longitude=${longitude}`)
            .set('Authorization', `Token token=${token}`)
            .set('Accept', 'application/json')
            .then(res => {
                resolve(res.body.result);
            })
            .catch(error => {
                reject(error);
            })
    });
}


export function GetAllCarousels(latitude: number, longitude: number, token: string) : Promise<Carousel[]> {
    return new Promise((resolve, reject) => {
        request
            .get(`${API_URL}carousels?latitude=${latitude}&longitude=${longitude}`)
            .set('Authorization', `Token token=${token}`)
            .set('Accept', 'application/json')
            .then(res => {
                resolve(res.body.result);
            })
            .catch(error => {
                reject(error);
            })
    });
}
